module.exports = __webpack_public_path__ + "static/media/rightmsgarrow.627896a9.webp";